/**
 * 通用资源保存失败时的用户可见提示。
 *
 * 为什么单独抽纯函数：创建页完成度（pendingCount）只覆盖粗粒度必填，
 * 合集绑定等细则失败时 pendingCount 可能为 0；若仍拼「请完成 0 项必填内容」会误导运营。
 * 优先展示 shell.validateAll 抛出的具体原因（如动作时长缺失）。
 *
 * @param {{ shellError?: string|null, pendingCount?: number|null }} input
 * @returns {string}
 */
export function buildGenericResourceSaveValidationMessage(input) {
  const raw = input && input.shellError
  const shellError = typeof raw === 'string' ? raw.trim() : ''
  if (shellError) {
    return shellError
  }

  const pendingCount = Number(input && input.pendingCount)
  const count = Number.isFinite(pendingCount) && pendingCount > 0 ? Math.floor(pendingCount) : 0
  if (count > 0) {
    return `请完成 ${count} 项必填内容`
  }

  // 主表单 / 类型未选等路径可能没有 shellError，且完成度已是 0——禁止再显示「0 项」
  return '请检查并完成必填内容'
}
